import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = { text: String }

  copy(event) {
    event.preventDefault()

    // Get the text to copy (priority: value > source target > button text)
    let textToCopy
    if (this.hasTextValue) {
      textToCopy = this.textValue
    } else if (this.hasSourceTarget) {
      textToCopy = this.sourceTarget.innerText || this.sourceTarget.textContent
    } else {
      // Fallback to the button's text content if neither value nor source is provided
      textToCopy = event.currentTarget.textContent.trim()
    }

    // Copy to clipboard
    navigator.clipboard.writeText(textToCopy).then(() => {
      // Get the button element (either target or event currentTarget)
      const button = this.hasButtonTarget ? this.buttonTarget : event.currentTarget

      // Store original button content
      const originalContent = button.innerHTML

      // Show success feedback
      button.innerHTML = `
        <svg class="mr-2 w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        Copié !
      `

      // Reset after 2 seconds
      setTimeout(() => {
        button.innerHTML = originalContent
      }, 2000)
    }).catch(() => {
      // Silent fail - clipboard API may not be available in some contexts
    })
  }
}
